// extracted by mini-css-extract-plugin
module.exports = {"root":"PageLayout_root__3EFrr","pageTitle":"PageLayout_pageTitle__36s7w"};